var _defs, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg3Historique(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 321 393.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: none;\n        stroke: #fff;\n        stroke-miterlimit: 10;\n        stroke-width: 15px;\n      }\n\n      .st1 {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M98.2,0c64.8,6.4,104.2,77.4,71.5,135.4-36.7,65.1-132.4,60.4-162.2-8.1C-17.1,70.9,21.4,5,82.6,0h15.6ZM81.7,19.8C38.4,24.2,10.4,69.1,21.9,110.5c16.9,61,100.5,70.7,131.1,15.2,28.6-51.8-13.1-111.9-71.4-105.9h0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M151.2,178.6h105.2c12.1,2,12.4,17.1,0,19.4h-105.4c-11.7-2.3-12-17.5.1-19.4h.1Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M145.4,239.7c1-.9,2.5-1.5,3.8-2.1l108.1-.5c12.8,2.9,10.6,19-2.4,19.6-32.5-2.4-69.6,3.2-101.5,0s-15-10.2-7.9-16.9h-.1Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M149.6,298.4h108.3c10.2,2.1,10.2,16.2,0,18.6h-107.9c-9.8-2.3-10.2-15.8-.6-18.6h.2Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M100.6,81.4h47.3c.3,0,3.8,2.4,4.3,2.9,4.5,5.1,2.5,13-3.7,15.6l-59.2.2c-4.3-.3-7.7-4.1-8.2-8.2-1.9-15.5,1.3-34.8.2-50.7,2.3-7.9,12.1-10.5,17-3.3s2.3,4.6,2.3,5.5v38h0Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M89.9,193.9l.5,154.2c0,9.4,3.5,18.5,9.9,25.5l2.2,2.5c5.7,6.2,13.7,9.8,22.1,9.8l152.6.5c11.5,0,22.3-5.4,29.1-14.6h0c4.7-6.3,7.2-13.9,7.2-21.7l-.5-242.3c0-8.8-3.8-17.2-10.5-23.1h0c-5.7-5-12.9-7.7-20.5-7.7l-88.5.2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3Historique);
export default __webpack_public_path__ + "static/media/3_Historique.58254cfe1720721435e22d3766478125.svg";
export { ForwardRef as ReactComponent };